// ---------------------------------------------------------------------------
// Canonical expression-accessor vocabulary for the studio (Expression Lab W2).
//
// Source-of-truth chain: expression-accessors-v1.ttl → @cogo/validator
// `VALID_EXPRESSION_METHODS` (stage-runtime-expr.ts). The validator's browser
// entry is not browser-safe, so the studio carries this mirror;
// `__tests__/expression-accessors.test.ts` locks parity against the validator
// export so the two can never drift. Same pattern as expression-prefixes.ts.
// ---------------------------------------------------------------------------

/** `.method()` names the Cogo expression evaluator implements. */
export const EXPRESSION_ACCESSOR_METHODS: ReadonlySet<string> = new Set([
  // String (10)
  'toUpperCase', 'toLowerCase', 'trim',
  'includes', 'startsWith', 'endsWith',
  'replace', 'substring', 'split', 'toString',
  // Number
  'toFixed',
  // Array (11)
  'map', 'filter', 'find', 'reduce', 'sort', 'slice', 'join', 'length',
  'unique', 'every', 'some',
  // Math (accessed via Math.xxx)
  'max', 'min', 'round', 'floor', 'ceil', 'abs', 'pow',
])

// Same shape as the validator's method scanner: `.method(` patterns only.
const METHOD_CALL_RE = /\.([a-zA-Z_]\w*)\s*\(/g

/**
 * Scan text for `.method(` calls whose method name is not in the canonical
 * accessor vocabulary. Returns deduped offender names (empty = clean).
 */
export function findInvalidAccessors(text: string): string[] {
  if (typeof text !== 'string' || !text.includes('.')) return []
  const found = new Set<string>()
  let m: RegExpExecArray | null
  METHOD_CALL_RE.lastIndex = 0
  while ((m = METHOD_CALL_RE.exec(text))) {
    if (!EXPRESSION_ACCESSOR_METHODS.has(m[1])) found.add(m[1])
  }
  return [...found]
}
